export const gitCommit = '12e05159'
